import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/close.svg'
import _imports_1 from './../assets/new-terminal.svg'
import _imports_2 from '../../globalModule/assets/icons/upload.png'
import _imports_3 from './../assets/search.svg'
import _imports_4 from '../../globalModule/assets/paper-plane.svg'
import _imports_5 from './../assets/rqt.svg'
import _imports_6 from './../assets/nodes-icon.svg'
import _imports_7 from './../assets/cube-icon.svg'
import _imports_8 from './../assets/binoculars-icon.svg'
import _imports_9 from './../assets/git-logo.png'
import _imports_10 from './../assets/download.svg'
import _imports_11 from './../assets/wrenches.svg'


const _withScopeId = n => (_pushScopeId("data-v-25408ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "heading-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "icon-button",
  target: "_blank",
  title: "Report Bug or Issue",
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfOkqKunFuJRsI8CqNlRKKNSrbBK56zWB2gMz0H9IVgP0hy0w/viewform"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_11 = { class: "subheading-div" }
const _hoisted_12 = { class: "connection-deets-box" }
const _hoisted_13 = { class: "shadowed-box" }
const _hoisted_14 = { class: "control-button-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_5
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "control-button-box" }
const _hoisted_18 = { class: "control-button-box" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_6
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "control-button-box" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_7
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "control-button-box" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_8
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "control-button-box" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_9
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-img",
    src: _imports_10
  })
], -1))
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_11
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "table-div" }
const _hoisted_37 = { class: "launch-table" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "launch-heading" }, "Launch File"),
  /*#__PURE__*/_createElementVNode("th", { class: "launch-heading" }, "Package Name"),
  /*#__PURE__*/_createElementVNode("th", { class: "launch-heading" }, "Path"),
  /*#__PURE__*/_createElementVNode("th", { class: "launch-heading" }, "Action")
], -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "empty-launch-row"
}, "No launch files found", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "launch-body" }
const _hoisted_43 = { class: "launch-body" }
const _hoisted_44 = { class: "launch-body" }
const _hoisted_45 = { class: "launch-body" }
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "launch-body" }
const _hoisted_49 = { class: "launch-body" }
const _hoisted_50 = { class: "launch-body" }
const _hoisted_51 = { class: "launch-body" }
const _hoisted_52 = ["onClick", "disabled"]
const _hoisted_53 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_LoadPackagesPopup = _resolveComponent("LoadPackagesPopup")!
  const _component_UploadTemplatePopup = _resolveComponent("UploadTemplatePopup")!
  const _component_BuildPackagesPopup = _resolveComponent("BuildPackagesPopup")!
  const _component_MountedExecute = _resolveComponent("MountedExecute")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExit()))
      }, _hoisted_3),
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/codeView/${_ctx.$route.params.workspaceId}`)))
      }, _hoisted_5),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.store.workspaceName), 1),
      (_ctx.userAdmin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "icon-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadTemplate = true))
          }, _hoisted_8))
        : _createCommentVNode("", true),
      _hoisted_9,
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, " Robot IP: " + _toDisplayString(_ctx.store.currConnection
            ? _ctx.store.currConnection.connectionDetails.hostname
            : '-'), 1),
        _createElementVNode("div", null, " Username: " + _toDisplayString(_ctx.store.currConnection
            ? _ctx.store.currConnection.connectionDetails.username
            : '-'), 1),
        _createElementVNode("div", null, " Port: " + _toDisplayString(_ctx.store.currConnection
            ? _ctx.store.currConnection.connectionDetails.port
            : '-'), 1),
        _createElementVNode("div", null, " Domain ID: " + _toDisplayString(_ctx.store.currConnection
            ? _ctx.store.currConnection.connectionDetails.domainId
            : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {
            {
              _ctx.$router.push(`/packageCanvas/${_ctx.$route.params.workspaceId}`);
            }
          })
          }, _hoisted_16),
          _createTextVNode(" ROS Canvas ")
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {
            {
              _ctx.$router.push(`/codeView/${_ctx.$route.params.workspaceId}`);
            }
          })
          }, [
            _createVNode(_component_fa, { icon: "code" })
          ]),
          _createTextVNode(" Code View ")
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "icon-button",
            disabled: !_ctx.store.currConnection,
            onClick: _cache[5] || (_cache[5] = ($event: any) => {
            {
              _ctx.runRosVnc('rqt', 2, 'rqt');
            }
          })
          }, _hoisted_21, 8, _hoisted_19),
          _createTextVNode(" RQT ")
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {
            {
              _ctx.openLink('http://localhost:7081/vnc_auto.html');
            }
          })
          }, _hoisted_24),
          _createTextVNode(" Simulator ")
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            disabled: !_ctx.store.currConnection,
            class: "icon-button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {
            {
              _ctx.runRosVnc('ros2 run rviz2 rviz2', 1, 'rviz');
            }
          })
          }, _hoisted_28, 8, _hoisted_26),
          _createTextVNode(" Visualiser ")
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openGit()))
          }, _hoisted_31),
          _createTextVNode(" Sync to Git ")
        ]),
        _createElementVNode("div", {
          class: "control-button-box",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.buildProject()))
        }, [
          _hoisted_32,
          _createTextVNode(" Export Code ")
        ]),
        _createElementVNode("div", {
          class: "control-button-box",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.buildPackagesOpen = true))
        }, [
          _createElementVNode("button", {
            class: "icon-button",
            disabled: !_ctx.store.currConnection
          }, _hoisted_35, 8, _hoisted_33),
          _createTextVNode(" Build Packages ")
        ])
      ]),
      (_ctx.store.currConnection)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rectangle-button connect-button red",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDisconnect()))
          }, " Disconnect "))
        : _createCommentVNode("", true),
      (!_ctx.store.currConnection)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "rectangle-button connect-button",
            onClick: _cache[12] || (_cache[12] = ($event: any) => {
        {
          _ctx.$router.push(`/controlCenter/${_ctx.$route.params.workspaceId}/connect`);
        }
      })
          }, " Connect "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("table", _hoisted_37, [
        _hoisted_38,
        (
          _ctx.store.launchFiles.length === 0 &&
          _ctx.getGeneratedLaunchFiles().length === 0
        )
          ? (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGeneratedLaunchFiles(), (pkgLaunchFile) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: pkgLaunchFile.pkgId
          }, [
            _createElementVNode("td", _hoisted_42, _toDisplayString(pkgLaunchFile.name), 1),
            _createElementVNode("td", _hoisted_43, _toDisplayString(pkgLaunchFile.pkgName), 1),
            _createElementVNode("td", _hoisted_44, _toDisplayString(pkgLaunchFile.path), 1),
            _createElementVNode("td", _hoisted_45, [
              (!_ctx.isLaunchFileRunning(pkgLaunchFile))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "rectangle-button",
                    disabled: 
              !_ctx.store.currConnection ||
              _ctx.store.currConnection.connectionDetails.buildDir === ''
            ,
                    onClick: ($event: any) => (_ctx.store.runLaunchFile(pkgLaunchFile))
                  }, " Launch ", 8, _hoisted_46))
                : _createCommentVNode("", true),
              (_ctx.isLaunchFileRunning(pkgLaunchFile))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "rectangle-button red",
                    onClick: ($event: any) => (_ctx.store.stopLaunchFile(pkgLaunchFile))
                  }, " Stop ", 8, _hoisted_47))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.launchFiles, (launch) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `${launch.name}${launch.pkgName}`
          }, [
            _createElementVNode("td", _hoisted_48, _toDisplayString(launch.name), 1),
            _createElementVNode("td", _hoisted_49, _toDisplayString(launch.pkgName), 1),
            _createElementVNode("td", _hoisted_50, _toDisplayString(launch.path), 1),
            _createElementVNode("td", _hoisted_51, [
              (!_ctx.isLaunchFileRunning(launch))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "rectangle-button",
                    onClick: ($event: any) => (_ctx.store.runLaunchFile(launch)),
                    disabled: !_ctx.store.currConnection
                  }, " Launch ", 8, _hoisted_52))
                : _createCommentVNode("", true),
              (_ctx.isLaunchFileRunning(launch))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "rectangle-button red",
                    onClick: ($event: any) => (_ctx.store.stopLaunchFile(launch))
                  }, " Stop ", 8, _hoisted_53))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_LoadPackagesPopup, {
      visible: _ctx.loadPackages,
      setVisible: 
      (visible) => {
        _ctx.loadPackages = visible;
        if (!visible) _ctx.loadMessages();
      }
    
    }, null, 8, ["visible", "setVisible"]),
    _createVNode(_component_UploadTemplatePopup, {
      visible: _ctx.uploadTemplate,
      exit: () => (_ctx.uploadTemplate = false)
    }, null, 8, ["visible", "exit"]),
    _createVNode(_component_BuildPackagesPopup, {
      isOpen: _ctx.buildPackagesOpen,
      exit: () => (_ctx.buildPackagesOpen = false)
    }, null, 8, ["isOpen", "exit"]),
    _createVNode(_component_MountedExecute, {
      onNowMounted: _cache[13] || (_cache[13] = () => _ctx.loadMessages())
    })
  ], 64))
}